<template>
	<div>
		<spinner v-if="paymethods.loading"/>
		<div v-else class="idi-table paymethods">
			<div class="idi-header">
				<div class="idi-cell">#</div>
				<div class="idi-cell">ID</div>
				<div class="idi-cell">{{ $t('labels.general.name') }}</div>
				<div class="idi-cell">{{ $t('labels.general.date') }}</div>
				<div class="idi-cell">{{ $t('labels.general.active') }}</div>
			</div>
			<div class="idi-row-empty" v-if="!paymethods.data.length">
				<div class="idi-cell">{{ $t('labels.general.empty') }}</div>
			</div>
			<payment-method-row v-for="paymethod in paymethods.data" :key="paymethod.id" :user_uid="user_uid" :value="paymethod" @reload="getPaymethods"/>
		</div>
		<payment-method-form v-if="modalBox.open" @close="modalBox.open=false" @success="onFormSuccess" :user_uid="user_uid"/>
	</div>
</template>

<script>
import ApiCollection from '@/classes/api/ApiCollection'
import PaymentMethodRow from './PaymentMethodRow'
import PaymentMethodForm from './PaymentMethodForm'
export default {
	components: {
		PaymentMethodRow,
		PaymentMethodForm
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			vue: this,
			paymethods: new ApiCollection(),
			modalBox: {
				open: false
			}
		}
	},
	methods: {
		getPaymethods () {
			this.paymethods.loading = true
			this.$api.subscriptions.paymentMethods.getAll(this, this.user_uid)
				.then(response => {
					this.$log.info('subscriptions', 'subscriptions.paymentMethods.getAll OK', response)()
					this.paymethods.data = response.body
				}).catch(error => {
					this.$log.error('subscriptions', 'subscriptions.paymentMethods.getAll ERROR', error)()
					this.paymethods.error = error
				}).finally(() => {
					this.paymethods.loading = false
				})
		},
		onFormSuccess () {
			this.modalBox.open = false
			this.$root.$emit('add-floating-box', { type: 'success', title: 'Success', message: 'Payment method created.' })
			this.getPaymethods()
		},
		onOpenModal () {
			this.modalBox.open = true
		}
	},
	created () {
		this.$parent.$on('open-modal-add-payment', this.onOpenModal)
	},
	beforeDestroy () {
		this.$parent.$off('open-modal-add-payment', this.onOpenModal)
	},
	mounted () {
		this.getPaymethods()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/subscriptions/PaymentMethods.vue